export const actionTypes = {
  GET_NOTIFICATIONS_SETTINGS: 'PROFILE.GET_NOTIFICATIONS_SETTINGS',
  GET_NOTIFICATIONS_SETTINGS_SUCCESS: 'PROFILE.GET_NOTIFICATIONS_SETTINGS_SUCCESS',
  GET_NOTIFICATIONS_SETTINGS_FAILURE: 'PROFILE.GET_NOTIFICATIONS_SETTINGS_FAILURE',
  SAVE_NOTIFICATIONS_SETTINGS: 'PROFILE.SAVE_NOTIFICATIONS_SETTINGS',
  SAVE_NOTIFICATIONS_SETTINGS_SUCCESS: 'PROFILE.SAVE_NOTIFICATIONS_SETTINGS_SUCCESS',
  SAVE_NOTIFICATIONS_SETTINGS_FAILURE: 'PROFILE.SAVE_NOTIFICATIONS_SETTINGS_FAILURE',
};

export function getNotificationsSettings() {
  return {
    type: actionTypes.GET_NOTIFICATIONS_SETTINGS,
  };
}

export function getNotificationsSettingsSuccess(payload) {
  return {
    type: actionTypes.GET_NOTIFICATIONS_SETTINGS_SUCCESS,
    payload,
  };
}

export function getNotificationsSettingsError(error) {
  return {
    type: actionTypes.GET_NOTIFICATIONS_SETTINGS_FAILURE,
    payload: error,
  };
}

export function saveNotificationsSettings(payload) {
  return {
    type: actionTypes.SAVE_NOTIFICATIONS_SETTINGS,
    payload,
  };
}

export function saveNotificationsSettingsSuccess(payload) {
  return {
    type: actionTypes.SAVE_NOTIFICATIONS_SETTINGS_SUCCESS,
    payload,
  };
}

export function saveNotificationsSettingsError(error) {
  return {
    type: actionTypes.SAVE_NOTIFICATIONS_SETTINGS_FAILURE,
    payload: error,
  };
}
